import { InjectionToken } from '@angular/core';
import { FortressConfig } from '@psu-pennstateit-swe/apis/fortress';
import { AnalyticsConfig } from '@psu-pennstateit-swe/utils/analytics';
import { CdnConfig } from '@psu-pennstateit-swe/utils/cdn';
import { AuthConfigWithDiscoveryDoc } from '@psu-pennstateit-swe/utils/security';

export interface AppConfig {
  environmentLabel: string;
  externalUrls: Record<string, string>;
  featureFlags: Record<string, boolean>;
}

export interface SsrmConfig {
  url: string;
  mockUrl?: string;
}

export interface RouteFeatureFlag {
  name: string;
  redirectTo: string;
}

export interface AppProperties {
  analytics: AnalyticsConfig;
  app: AppConfig;
  cdn: CdnConfig;
  fortress: FortressConfig;
  oauth: AuthConfigWithDiscoveryDoc;
  ssrm: SsrmConfig;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
export const APP_PROPERTIES = new InjectionToken<AppProperties>('app.properties');
export const SSRM_CONFIG = new InjectionToken<SsrmConfig>('ssrm.config');
